import {
  HEALTH_ABOUT_YOU_STEP,
  HEALTH_PRICE_STEP,
  HEALTH_YOUR_HEALTH_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/Health";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { booleanToFormBoolean } from "Utils/formUtils";

export const mapFromCommerceHealthWithoutSigning = (
  data: Record<string, any>,
): FormState => {
  const {
    isFitForWork,
    inTreatment,
    isPlannedAnyKindOfTreatment,
    hasNationalInsurance,
    isSmoker,
  } = data.healthQuestions;
  const health = {
    [HEALTH_ABOUT_YOU_STEP.id]: {
      isMemberOfNordicSocialSecurity:
        booleanToFormBoolean(hasNationalInsurance),
    },
    [HEALTH_PRICE_STEP.id]: {
      coverage: data.coverageGroup,
    },
  };

  const healthWithoutSigningDetails = {
    [HEALTH_YOUR_HEALTH_STEP.id]: {
      isOnSickLeave: BooleanFormType.FALSE,
      isFitForWork: booleanToFormBoolean(isFitForWork),
      inTreatment: booleanToFormBoolean(inTreatment),
      isPlannedAnyKindOfTreatment: booleanToFormBoolean(
        isPlannedAnyKindOfTreatment,
      ),
      isSmoker: booleanToFormBoolean(isSmoker),
    },
  };

  return data.name === INSURANCE_NAME_VALUE.HEALTH_WITHOUT_SIGNING
    ? { ...health, ...healthWithoutSigningDetails }
    : health;
};
